(function () {
    'use strict';

    angular.module('swif.interventions')
    .directive('swifAssignedTo', swifAssignedTo);

    swifAssignedTo.$inject = ['swifFrameworkService', 'gettextCatalog'];
    function swifAssignedTo (swif, gettextCatalog) {
        var d = angular.copy(swif.form.DEFAULT_WIDGET_DIRECTIVE);
        d.scope.ngModel = '=';
        d.scope.action = '=';
        d.scope.filters = '=';
        d.scope.isUserPartner = '=';
        d.scope.partnerValue = '=';
        d.scope.taskNotify = '=';
        d.scope.fromTemplate = '=';

        delete d.require;
        d.link = link;
        d.templateUrl = 'partials/openstc/form_assigned_to.html';
        return d;

        function link (scope, element, attr) {
            scope.translate = {
                'personsToNotify': gettextCatalog.getString('Notifier la/les personne(s) assignée(s) par mail'),
                'onePersonToNotify': gettextCatalog.getString('Notifier la personne assignée par mail')
            };

            swif.form.watchNgRequired(scope, element);
            swif.form.copyAttributesToInput(scope, element, attr);
            scope.form = scope.$parent.form;
            scope.choices = [
                {id: 0, name: 'officer', field:'user_id', type:'user', icon: '<i class="fa fa-user"></i>'},
                {id: 1, name: 'team', field:'team_id', type:'team', icon: '<i class="fa fa-users"></i>'},
                {id: 2, name: 'partner', field:'partner_id', type:'partner', icon: '<i class="fa fa-truck"></i>'}
            ];
            scope.setCurrent = setCurrent;
            if (scope.ngModel) {
                if (scope.isUserPartner && scope.partnerValue) {
                    scope.ngModel.partner_id = scope.partnerValue;
                    scope.setCurrent(scope.choices[2]);
                } else if (!scope.ngModel.user_id && !scope.ngModel.team_id && !scope.ngModel.partner_id) {
                    scope.setCurrent(scope.choices[0]);
                }
                if (scope.ngModel.partner_id) {
                    scope.partnerFilter = getContactFilter(scope.ngModel.partner_id[0])
                    if(scope.ngModel.partner_address) {
                        var filter = {};
                        filter.fields = ['email'];
                        swif.data.get('partner_address', scope.ngModel.partner_address[0], filter).then(function (data) {
                            scope.emailPartner = data.email;
                        })
                    }
                }
            }
            scope.$watch('ngModel.user_id', watchUserId);
            scope.$watch('ngModel.team_id', watchTeamId);
            scope.$watch('ngModel.partner_id', watchPartnerId);
            scope.$watch('model.user_id', watchUserId2, true);
            scope.$watch('ngModel', watchNgModel);

            function resetUserAndTeam (model) {
                if (model.user_id) {
                    model.user_id = false;
                }
                if (model.team_id) {
                    model.team_id = false;
                }
            }
            function resetTeamAndPartner (model) {
                if (model.team_id) {
                    model.team_id = false;
                }
                if (model.partner_id) {
                    model.partner_id = false;
                }
            }
            function resetPartnerAndUser (model) {
                if (model.user_id) {
                    model.user_id = false;
                }
                if (model.partner_id) {
                    model.partner_id = false;
                }
            }
            function setCurrent (choice) {
                scope.currentChoice = choice;
                scope.type = choice.type;
                var vv = scope.ngModel;
                if (scope.currentChoice.id === 0) {
                    resetTeamAndPartner(vv);
                } else if (scope.currentChoice.id === 1) {
                    resetPartnerAndUser(vv);
                } else if (scope.currentChoice.id === 2) {
                    resetUserAndTeam(vv);
                }
            }

            function watchUserId (newV) {
                if (newV) {
                    scope.setCurrent(scope.choices[0]);
                }
            }
            function watchTeamId (newV) {
                if (newV) {
                    scope.setCurrent(scope.choices[1]);
                }
            }
            function watchPartnerId (newV) {
                if (newV) {
                    scope.setCurrent(scope.choices[2]);
                }
            }
            function watchUserId2 (newV) {
                if (newV) {
                    if (scope.currentChoice.id !== 0) {
                        scope.setCurrent(scope.choices[0]);
                    }
                    if (scope.proxy.selected) {
                        if (scope.proxy.selected.id && scope.proxy.selected.id !== newV[0]) {
                            scope.proxy.selected = {id: newV[0], name: newV[1]};
                        }
                    } else {
                        scope.proxy.selected = {id: newV[0], name: newV[1]};
                    }
                }
            }
            function watchNgModel (newV) {

                if (newV && !scope.currentChoice) {
                    if (!newV.user_id && !newV.team_id && !newV.partner_id) {
                        scope.setCurrent(scope.choices[0]);
                    }
                }
            }

            function getContactFilter (partnerId) {
                var filter = {fields: ['name', 'complete_name', 'email']};
                swif.data.addFilter(filter, 'partner_id', '=', partnerId || 0);
                return filter;
            };

            scope.onChangePartner = onChangePartner;
            function onChangePartner (newV) {
                scope.partnerFilter = getContactFilter(newV.id);
            };

            scope.onChangeContact = onChangeContact;
            function onChangeContact (newV) {
                scope.emailPartner = newV.email;
            };
        }
    }

})();
